import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone, Mail, MapPin, Menu, X } from 'lucide-react';
import { companyInfo } from '../mockData';

const Navbar = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [scrolled, setScrolled] = React.useState(false);
  const { pathname }= useLocation();
  const isPrivacy = pathname === '/privacy' || pathname === '/terms';

  React.useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {/* Top Bar */}
      <div className={`${isPrivacy ? 'bg-gray-950 border-b border-gray-800' : 'bg-gradient-to-r from-blue-900 to-blue-800'} text-white py-2 px-4`}>
        <div className="container mx-auto flex flex-wrap justify-between items-center text-sm">
          <div className="flex items-center gap-4 flex-wrap">
            <a href={`mailto:${companyInfo.corporateOffice.email}`} className="flex items-center gap-2 hover:text-blue-200 transition-colors">
              <Mail className="w-4 h-4" />
              <span className="hidden sm:inline">{companyInfo.corporateOffice.email}</span>
            </a>
            <a href={`tel:${companyInfo.corporateOffice.phone}`} className="flex items-center gap-2 hover:text-blue-200 transition-colors">
              <Phone className="w-4 h-4" />
              <span>{companyInfo.corporateOffice.phone}</span>
            </a>
          </div>
          <div className="hidden md:flex items-center gap-2 text-xs">
            <span className="bg-blue-700 px-3 py-1 rounded-full">WHO-GMP Certified</span>
            <span className="bg-blue-700 px-3 py-1 rounded-full">ISO Certified</span>
          </div>
        </div>
      </div>

      {/* Main Navbar */}
      <nav className={`sticky top-0 z-50 transition-all duration-300 ${scrolled ? (isPrivacy ? 'bg-gray-950 shadow-lg' : 'bg-white shadow-lg') : (isPrivacy ? 'bg-gray-950' : '')}`}>
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center py-4">
            {/* Logo */}
            <Link to="/" className="flex items-center group">
            <img
              src="/logo.png"
              alt="Vetam Remedies Logo"
              className="h-16 w-auto object-contain" 
              style={{ filter: isPrivacy ? 'brightness(0) invert(1)': 'none'}}      /*//can do this if logo aint visible but it's gonna turn the logo white */     
            />
            </Link>

            {/* Desktop Menu */}
            <div className="hidden lg:flex items-center gap-8">
              <Link to="/" className="text-gray-700 hover:text-blue-600 font-medium transition-colors">Home</Link>
              <Link to="/products" className="text-gray-700 hover:text-blue-600 font-medium transition-colors">Products</Link>
              <Link to="/about" className="text-gray-700 hover:text-blue-600 font-medium transition-colors">About Us</Link>
              <Link to="/partners" className="text-gray-700 hover:text-blue-600 font-medium transition-colors">Our Partners</Link>
              <Link to="/contact" className="text-gray-700 hover:text-blue-600 font-medium transition-colors">Contact</Link>
              <Link to="/become-partner" className="bg-gradient-to-r from-blue-600 to-blue-700 text-white px-6 py-2.5 rounded-lg font-semibold hover:shadow-lg transform hover:-translate-y-0.5 transition-all">
                Become a Partner
              </Link>
            </div>

            {/* Mobile Menu Button */}
            <button onClick={() => setIsOpen(!isOpen)} className="lg:hidden p-2 text-gray-700 hover:text-blue-600">
              {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>

          {/* Mobile Menu */}
          {isOpen && (
            <div className="lg:hidden py-4 border-t border-gray-200">
              <div className="flex flex-col gap-4">
                <Link to="/" onClick={() => setIsOpen(false)} className="text-gray-700 hover:text-blue-600 font-medium py-2 transition-colors">Home</Link>
                <Link to="/products" onClick={() => setIsOpen(false)} className="text-gray-700 hover:text-blue-600 font-medium py-2 transition-colors">Products</Link>
                <Link to="/about" onClick={() => setIsOpen(false)} className="text-gray-700 hover:text-blue-600 font-medium py-2 transition-colors">About Us</Link>
                <Link to="/partners" onClick={() => setIsOpen(false)} className="text-gray-700 hover:text-blue-600 font-medium py-2 transition-colors">Our Partners</Link>
                <Link to="/contact" onClick={() => setIsOpen(false)} className="text-gray-700 hover:text-blue-600 font-medium py-2 transition-colors">Contact</Link>
                <Link to="/become-partner" onClick={() => setIsOpen(false)} className="bg-gradient-to-r from-blue-600 to-blue-700 text-white px-6 py-2.5 rounded-lg font-semibold text-center">
                  Become a Partner
                </Link>
              </div>
            </div>
          )}
        </div>
      </nav>
    </>
  );
};

export default Navbar;
